export default __webpack_public_path__ + "static/media/v-bt-l.1a9f8c56.png";